import { Pipe, PipeTransform } from '@angular/core';
import { TicketData } from '../../../core/modules/tickets/ticket.types';
import { REGEXP_TICKET_DESCRIPTION } from '../../../core/services/regexp';

@Pipe({
  name: 'ticketDescription',
  standalone: true,
})
export class TicketDescriptionPipe implements PipeTransform {
  transform(ticketData: TicketData):string[] {
    return ticketData.ticketDescription.match(REGEXP_TICKET_DESCRIPTION) || [];
  }
}
